export const RECOMMEND_FORM_LOADING_STATES = {
    GET_GUIDED_FORMS_LOADING: "GET_GUIDED_FORMS_LOADING",
    GET_GUIDED_FORMS_READY: "GET_GUIDED_FORMS_READY"
}